import SvgIcon from '@/pages/home/components/SvgIcon';
import React, { useEffect, useState } from 'react';
import { Bubble, Card } from 'tea-component';
import './index.scss';

const ListIcon = [
  { id: 1, context: '柱状图', icon: 'pie-chart-icon' },
  { id: 2, context: '折线图', icon: 'discount-chart' },
  { id: 3, context: '饼状图', icon: 'column-chart' },
];

export default function CardSlot(props: any) {
  // children:  插入内容
  // title: 标题这里字符串和dom元素都可以
  // activeTab: 当前选择tab
  // isEyes: 是否展示右侧的眼睛查看icon  默认flase不展示，  true的话展示
  // isDownload: 是否展示右侧的下载  默认flase不展示，  true的话展示
  // iconList: 右边的icon 不传的话只显示下载
  // isAction: 如果需要左边右边箭头可以点击去的 true ，默认flase， 可以不传
  // getChange：右边按钮点击事件
  // getEyes: 显示不显示事件按钮
  // onDownload： 下载事件按钮
  // className： 传的类名
  const {
    children,
    title,
    activeTab,
    isEyes,
    isDownload,
    iconList = ListIcon,
    isAction,
    isTitleAction,
    getChange,
    getEyes,
    onDownload,
    className,
    getDetails,
    rightDom,
    isShowRightDom = ''
  } = props;
  const [isShow, setIsShow] = useState(false);
  return (
    <>
      <Card className={`card-sort ${className}`}>
        {title ? (
          <Card.Body
            title={
              isAction ? (
                <div
                  className={
                    isAction ? 'card-sort-title-hover' : 'card-sort-title'
                  }
                  onClick={getDetails}
                >
                  <span>{title}</span>
                  <SvgIcon type="arrow-right" className="card-sort-icon" />
                </div>
              ) : isTitleAction ? (
                <div
                  className={
                    isAction ? 'card-sort-title-hover' : 'card-sort-title'
                  }
                  onClick={getDetails}
                >
                  <span>{title}</span>
                </div>
              ): title
            }
            operation={
              rightDom ? (
                rightDom
              ) : (
                <div className={`card-sort-flex${isShowRightDom}`}>
                  {isEyes ? (
                    <Bubble dark content={isShow ? '不显示' : '显示'}>
                      <i
                        onClick={() => {
                          setIsShow(!isShow);
                          getEyes(isShow);
                        }}
                        className="card-sort-item"
                      >
                        <SvgIcon
                          className="card-sort-charicon"
                          type={isShow ? 'eyes-closed' : 'open-eyes'}
                        />
                      </i>
                    </Bubble>
                  ) : null}
                  {iconList?.map((e: any, i: any) => {
                    return (
                      <Bubble content={e.context} dark key={i}>
                        <i
                          className={
                            e.icon == activeTab
                              ? 'card-sort-action'
                              : 'card-sort-item'
                          }
                          onClick={() => {
                            getChange(e.value);
                          }}
                        >
                          <SvgIcon
                            type={e.icon}
                            className="card-sort-charicon"
                          />
                        </i>
                      </Bubble>
                    );
                  })}
                  {isDownload ? (
                    <Bubble dark>
                      <i className="card-sort-char" onClick={onDownload}>
                        <SvgIcon
                          type="download"
                          className="card-sort-charicon"
                        />
                      </i>
                    </Bubble>
                  ) : null}
                </div>
              )
            }
          >
            {children ? children : <div className="line-text">图表占位</div>}
          </Card.Body>
        ) : (
          <Card.Body>{children}</Card.Body>
        )}
      </Card>
    </>
  );
}
